module.exports = __webpack_public_path__ + "static/img/no-help-select.ec819cd3.png";